import { inject, ElementRef, HostBinding, ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { BehaviorSubject } from 'rxjs';

let uid = 0;

@Component({
    selector: 'radio-expandable',
    templateUrl: './radio-expandable.html',
    styleUrls: ['./radio-expandable.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadioExpandableComponent<T = any> extends UiComponent {
    @Input({ required: true })
    name: string;

    @Input()
    @HostBinding('class._disabled')
    disabled = false;

    @Input({ required: true })
    value: T;

    @Input()
    model!: T;

    @Output()
    modelChange = new EventEmitter<T>();

    protected toggleState = new BehaviorSubject(false);

    private elementRef = inject(ElementRef);

    override ngOnInit() {
        this.modelChange.subscribe(v => {
            this.updateToggleState();
        });
        super.ngOnInit();
    }

    override ngOnChanges(changes) {
        this.updateToggleState();
        super.ngOnChanges(changes);
    }

    onChange(value: T) {
        this.modelChange.emit(value);
        if (value === this.value) {
            this.onPick();
        }
    }

    protected pick() {
        this.model = this.value;
        this.modelChange.next(this.value);
        this.detectChanges();
        this.onPick();
    }

    private onPick() {
        this.timeoutService.setTimeout(() => {
            this.elementRef.nativeElement.scrollIntoView({ behavior: 'smooth' });
        }, 500);
    }

    private updateToggleState() {
        const value = this.value && this.model === this.value;
        if (value !== this.toggleState.value) {
            this.toggleState.next(value);
        }
    }
}
